__turbopack_context__.v({
  "about": "services-module__vv4jMG__about",
  "aboutCopy": "services-module__vv4jMG__aboutCopy",
  "aboutGrid": "services-module__vv4jMG__aboutGrid",
  "aboutInfo": "services-module__vv4jMG__aboutInfo",
  "aboutLogo": "services-module__vv4jMG__aboutLogo",
  "aboutVisual": "services-module__vv4jMG__aboutVisual",
  "benefits": "services-module__vv4jMG__benefits",
  "benefitsGrid": "services-module__vv4jMG__benefitsGrid",
  "brand": "services-module__vv4jMG__brand",
  "brandGroup": "services-module__vv4jMG__brandGroup",
  "brandIcon": "services-module__vv4jMG__brandIcon",
  "brandText": "services-module__vv4jMG__brandText",
  "campaign": "services-module__vv4jMG__campaign",
  "cardDescription": "services-module__vv4jMG__cardDescription",
  "cardEyebrow": "services-module__vv4jMG__cardEyebrow",
  "cartAction": "services-module__vv4jMG__cartAction",
  "catalogHeader": "services-module__vv4jMG__catalogHeader",
  "catalogSection": "services-module__vv4jMG__catalogSection",
  "contact": "services-module__vv4jMG__contact",
  "contactButton": "services-module__vv4jMG__contactButton",
  "container": "services-module__vv4jMG__container",
  "detailsButton": "services-module__vv4jMG__detailsButton",
  "emptyState": "services-module__vv4jMG__emptyState",
  "eyebrow": "services-module__vv4jMG__eyebrow",
  "filters": "services-module__vv4jMG__filters",
  "footerBottom": "services-module__vv4jMG__footerBottom",
  "footerGrid": "services-module__vv4jMG__footerGrid",
  "header": "services-module__vv4jMG__header",
  "headerActions": "services-module__vv4jMG__headerActions",
  "headerCart": "services-module__vv4jMG__headerCart",
  "headerCartIcon": "services-module__vv4jMG__headerCartIcon",
  "headerCartLabel": "services-module__vv4jMG__headerCartLabel",
  "headerInner": "services-module__vv4jMG__headerInner",
  "hero": "services-module__vv4jMG__hero",
  "imageFallback": "services-module__vv4jMG__imageFallback",
  "location": "services-module__vv4jMG__location",
  "menuToggle": "services-module__vv4jMG__menuToggle",
  "navigation": "services-module__vv4jMG__navigation",
  "navigationOpen": "services-module__vv4jMG__navigationOpen",
  "outlineButton": "services-module__vv4jMG__outlineButton",
  "platformBar": "services-module__vv4jMG__platformBar",
  "primaryButton": "services-module__vv4jMG__primaryButton",
  "productBody": "services-module__vv4jMG__productBody",
  "productCard": "services-module__vv4jMG__productCard",
  "productImage": "services-module__vv4jMG__productImage",
  "productPrice": "services-module__vv4jMG__productPrice",
  "productsGrid": "services-module__vv4jMG__productsGrid",
  "productsSection": "services-module__vv4jMG__productsSection",
  "reference": "services-module__vv4jMG__reference",
  "resultInfo": "services-module__vv4jMG__resultInfo",
  "reviews": "services-module__vv4jMG__reviews",
  "search": "services-module__vv4jMG__search",
  "sectionHeading": "services-module__vv4jMG__sectionHeading",
  "serviceBody": "services-module__vv4jMG__serviceBody",
  "serviceBottom": "services-module__vv4jMG__serviceBottom",
  "serviceCard": "services-module__vv4jMG__serviceCard",
  "serviceImage": "services-module__vv4jMG__serviceImage",
  "servicePrice": "services-module__vv4jMG__servicePrice",
  "servicesGrid": "services-module__vv4jMG__servicesGrid",
  "servicesSection": "services-module__vv4jMG__servicesSection",
  "storefront": "services-module__vv4jMG__storefront",
  "verified": "services-module__vv4jMG__verified",
});
